"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paybackButton = void 0;
const merge_1 = __importDefault(require("lodash/merge"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const colors_1 = require("./colors");
const Button_1 = require("../../components/atoms/Button/Button");
const button_1 = require("./button");
const paybackButton = merge_1.default(cloneDeep_1.default(button_1.button), {
    type: {
        [Button_1.ButtonAction.PRIMARY]: {
            backgroundColor: colors_1.colors.payback,
            inverted: {
                color: colors_1.colors.payback,
            },
        },
        [Button_1.ButtonAction.SECONDARY]: {
            borderColor: colors_1.colors.payback,
        },
    },
});
exports.paybackButton = paybackButton;
